module.exports = __webpack_public_path__ + "static/img/smoke.c342704.png";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/smoke.png
// module id = +1zG
// module chunks = 1